
import { Component, Vue } from 'vue-property-decorator';
import Topbar from '@/core/components/Topbar.vue';
import PageLoader from '@/core/components/PageLoader.vue';
import { namespace } from 'vuex-class';

const coreNamespace = namespace('core');

@Component({
	components: {
		Topbar,
		PageLoader,
	},
})
export default class App extends Vue {
	@coreNamespace.State('isPageLoaderShown')
	public isPageLoaderShown!: boolean;

	@coreNamespace.Action('initializeWindowResizeListener')
	public initializeWindowResizeListener!: () => void;

	mounted() {
		this.initializeWindowResizeListener();
	}
}
